module.exports = __WEBPACK_EXTERNAL_MODULE_118__;


//////////////////
// WEBPACK FOOTER
// external "tether"
// module id = 118
// module chunks = 0